import appleEmojis from 'emoji-mart/data/apple.json';
import 'emoji-mart/css/emoji-mart.css';

export const emojisCollectionData = appleEmojis;

export const emojisCollectionName = 'apple';
